var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        class: _vm.$style.container
    }, [
        _c('div', {
            class: _vm.$style.circleSmall
        }),
        _c('div', {
            class: _vm.$style.circleLarge
        }),
        _c('div', {
            class: _vm.$style.content
        }, [
            _c('object', {
                attrs: {
                    "type": "image/svg+xml",
                    "data": _setup.yxhTextSvg
                }
            }),
            _c('p', [
                _vm._v("正在尝试打开宜享花APP...")
            ])
        ]),
        _c('van-overlay', {
            attrs: {
                "show": _setup.visibleMap.overlay,
                "z-index": 10
            },
            on: {
                "click": function($event) {
                    _setup.visibleMap.overlay = false;
                }
            }
        }, [
            _c('div', {
                class: _vm.$style.downloadTips
            }, [
                _c('img', {
                    attrs: {
                        "src": require("@/assets/img/guidance.png"),
                        "alt": ""
                    }
                }),
                _c('p', [
                    _vm._v("点击右上角的按钮")
                ]),
                _c('p', [
                    _vm._v("在浏览器中打开宜享花APP")
                ])
            ])
        ])
    ], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
